module.exports = __webpack_public_path__ + "img/table_order.e4c87981.svg";